export const isHabbitHostname = () => {
  if (process.env.NEXT_PUBLIC_SITE === 'jml') {
    return false
  }

  return true
}
